import React from 'react';
import './NavBarHome.css';
import { Link } from "react-router-dom";


function SecondNavbarHome() {
  return (
    <div className="navbarhome">
      <p className='titulo-barra' >xxxx </p>

    </div>
  );
}

export default SecondNavbarHome;
